export const colors = [
	"#000000", // black
	"#1f2937", // gray-800
	"#374151", // gray-700
	"#4b5563", // gray-600
	"#2563eb", // blue-600
	"#3b82f6", // blue-500
	"#60a5fa", // blue-400
	"#93c5fd", // blue-300
	"#16a34a", // green-600
	"#22c55e", // green-500
	"#4ade80", // green-400
	"#86efac", // green-300
	"#65a30d", // lime-600
	"#84cc16", // lime-500
	"#a3e635", // lime-400
	"#c0f66b", // lime-300
	"#f59e0b", // yellow-600
	"#fbbf24", // yellow-500
	"#fcd34d", // yellow-400
	"#fde68a", // yellow-300
	"#ea580c", // orange-600
	"#f97316", // orange-500
	"#fb923c", // orange-400
	"#f9ac64", // orange-300
	"#dc2626", // red-600
	"#ef4444", // red-500
	"#f87171", // red-400
	"#fbb6b9", // red-300
	"#db2777", // pink-600
	"#ec4899", // pink-500
	"#f472b6", // pink-400
	"#f9a8d4", // pink-300
	"#7c3aed", // purple-600
	"#9333ea", // purple-500
	"#ae3afc", // purple-400
	"#d4aaff", // purple-300
];

export const highlightColors = [
	"#4b5563", // gray-600
	"#93c5fd", // blue-300
	"#86efac", // green-300
	"#c0f66b", // lime-300
	"#fde68a", // yellow-300
	"#f9ac64", // orange-300
	"#fbb6b9", // red-300
	"#f9a8d4", // pink-300
	"#d4aaff", // purple-300
];
